import styles from './OrderSummaryCard.module.scss';
import { CartItemBodyProps } from './OrderSummaryCardBody';
import ProgramRegistrationsTable from './ProgramRegistrationsTable';

export default function OrderSummaryCardDetails({
  cartItemUuid,
  subprograms = [],
  subtype,
}: Readonly<
  Pick<CartItemBodyProps, 'cartItemUuid' | 'subprograms' | 'subtype'>
>) {
  return (
    <div
      className={styles.orderSummaryCardDetails}
      data-testid="order-summary-card-details"
    >
      <ProgramRegistrationsTable
        cartItemUuid={cartItemUuid}
        subprograms={subprograms}
        subtype={subtype}
      />
    </div>
  );
}
